import LookupLecturerModulesRequestModelBase from '../_generated/modelBases/lookup-lecturer-modules-request-model-base';

export default class LookupLecturerModulesRequestModel extends LookupLecturerModulesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
